import request from "superagent";

import { getTabToken } from "common/MetaActions";
import config from "config/config";
import { useRootStore } from "store";
import { DocumentService } from "models/wizard/WizardState";

export class DocumentServicesAPI {
  static async getDocumentServices(id: string) {
    const result = await request
      .get(config.api.documentService.get(id))
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send();
    return result.body;
  }

  static async saveCustomerDocumentArchiveSettings(
    id: string,
    documentServices: DocumentService[]
  ) {
    const { user } = useRootStore.getState();
    return await request
      .put(config.api.documentService.put(id))
      .set("Authorization", `Bearer ${user.token}`)
      .send(documentServices);
  }
}
